import { useState } from 'react';
import { useWindowDimensions } from 'react-native';

const SCREEN_WIDTHS = {
  mobile: [0, 800],
  tablet: [800, 1400],
  full: [1400, null],
};

const useScreenSize = () => {
  const { width } = useWindowDimensions();

  const isScreenSize = size => {
    const maxWidth = SCREEN_WIDTHS[size][1];
    if (!maxWidth) { return true; }
    return width <= maxWidth;
  }

  const isExactScreenSize = size => {
    return width > SCREEN_WIDTHS[size][0] && (
      !SCREEN_WIDTHS[size][1] || width <= SCREEN_WIDTHS[size][1]
    )
  }

  const aboveScreenSize = size => !isScreenSize(size);

  return { isScreenSize, isExactScreenSize, aboveScreenSize };
};

export default useScreenSize;
